export enum ConnectionType {
    None,
    ImapSmtp,
    PopSmtp,
    SmtpOnly,
}
